import { BrandHeadline, SeeAllHere } from 'autogen/translation-keys/trans-website-articleblock';
import type { BrandDetailedModelMaybe } from 'autogen/swagger/all';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import {
    FontFontFamilyPrimary,
    ColorBrandBlue1,
    FontCaptionLineHeightMedium,
    FontFontFamilySecondary
} from 'autogen/design-tokens/tokens';
import PictureDeprecated from 'components/generic/picture/PictureDeprecated';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    background-color: #ffffff;
    padding: 20px;
    margin-bottom: 30px;
`;

const Headline = styled.div`
    color: ${ColorBrandBlue1};
    padding: 0 20px;
    line-height: ${FontCaptionLineHeightMedium};
    font-family: ${FontFontFamilySecondary};
`;

const ImageContainer = styled.div`
    margin: 20px auto;
    max-width: 50%;

    ${breakpoint.up(sizes.md)} {
        max-width: initial;
    }
`;

const SeeAllHereContainer = styled.a`
    text-align: center;
    font-family: ${FontFontFamilyPrimary};
    font-weight: bold;
    width: auto;
    color: ${ColorBrandBlue1};
    margin-top: 0.36em;
    margin-bottom: 0.36em;
`;

export default function Brand(props: BrandDetailedModelMaybe) {
    const { logo, url } = props;
    const { t } = useTranslation();

    return (
        <Container>
            <Headline>{t(BrandHeadline)}</Headline>
            {logo && (
                <ImageContainer>
                    <a href={url}>
                        <PictureDeprecated {...logo.image} />
                    </a>
                </ImageContainer>
            )}
            <SeeAllHereContainer href={url}>{t(SeeAllHere)}</SeeAllHereContainer>
        </Container>
    );
}
